import { useEffect } from "react";
import { WP_URL } from "@/config";

const IframeContainer = ({ children }: { children: React.ReactNode }) => {

  

  const postIframeHeight = () => {
    const height = document.documentElement.offsetHeight;

    const message = { iframePath: window.location.pathname, iframeHeight: height }
    
    // WP_URLが設定されている場合はそれを使用、そうでなければ現在のオリジン
    const targetOrigin = WP_URL || window.location.origin;
    
    try {
      window.parent.postMessage(message, targetOrigin);
    } catch (error) {
      console.warn('postMessage failed:', error);
    }
  }

  const isIframe = window.parent !== window;

  useEffect(() => {
    postIframeHeight();
    
    // resizeイベント
    window.addEventListener('resize', postIframeHeight);
    
    // DOM変更を監視（サイズが変わった時のみ反応）
    let lastHeight = document.documentElement.offsetHeight;
    const observer = new MutationObserver(() => {
      // DOM変更後に少し待ってからサイズをチェック
      setTimeout(() => {
        const currentHeight = document.documentElement.offsetHeight;
        if (currentHeight !== lastHeight) {
          lastHeight = currentHeight;
          postIframeHeight();
        }
      }, 50);
    });
    
    observer.observe(document.body, {
      childList: true,        // 子要素の追加・削除
      subtree: true,          // 子孫要素も監視
      attributes: true,       // 属性の変更
      characterData: true     // テキストの変更
    });

    return () => {
      window.removeEventListener('resize', postIframeHeight);
      observer.disconnect();
    }
  }, []);

  return <div className={`${isIframe ? 'iframe-container' : ''}`}>{children}</div>;
}

export default IframeContainer;